import clsx from "clsx";
import Nav from "../components/nav/Nav";

export const AppLayout = ({
  children,
  bg,
  noNav,
  activeClass,
  activeColor,
  inactiveClass,
  navBg,
  firstIcon,
  secondIcon,
  thirdIcon,
  fourthIcon,
  firstText,
  secondText,
  thirdText,
  fourthText,
  mainClass,
  firstLink,
  secondLink,
  thirdLink,
  fourthLink,
}) => {
  return (
    <div
      className={clsx(
        bg,
        "480:max-w-[440px] min-h-screen 480:mx-auto 480:flex 480:flex-col 480:justify-center"
      )}
    >
      <div
        className={clsx(
          bg,
          "h-full 480:h-[800px] overflow-y-hidden 480:p-5 relative 480:shadow-xl 480:shadow-blue-500",
          mainClass
        )}
      >
        <div className="h-full 480:h-[760px] 480:overflow-y-scroll thin-scrollbar">
          <div className={clsx(bg, "480:w-full 480:h-full 480:bg-white")}>
            <div className={clsx(bg, "bg-white h-full")}>{children}</div>
          </div>
        </div>
        {!noNav && (
          <Nav
            navBg={navBg}
            firstText={firstText}
            secondText={secondText}
            thirdText={thirdText}
            fourthText={fourthText}
            firstIcon={firstIcon}
            secondIcon={secondIcon}
            thirdIcon={thirdIcon}
            fourthIcon={fourthIcon}
            activeClass={activeClass}
            activeColor={activeColor}
            inactiveClass={inactiveClass}
            firstLink={firstLink}
            secondLink={secondLink}
            thirdLink={thirdLink}
            fourthLink={fourthLink}
          />
        )}
      </div>
    </div>
  );
};
